export default function React_Forms() {
  return (
    <div>
      <h1>React_Forms Component</h1>
      <p>This is the React_Forms tutorial page.</p>
    </div>
  );
}
